import DOMPurify from "dompurify";

// Sanitize untrusted HTML before it is injected via dangerouslySetInnerHTML.
//
// Inbound email bodies (MailPage) are fully attacker-controlled: anyone can
// email a CRM contact, and the operator opens that mail inside the CRM's
// authenticated first-party origin. Without sanitization an
// `<img src=x onerror=...>` (or <script>) runs with the operator's session.
// Campaign previews (CampaignsPage) are staff-authored but rendered the same
// way, so we sanitize both paths.
//
// DOMPurify strips <script>, on* event handlers, javascript:/data: script
// URLs, and other active content while preserving ordinary formatting and
// images. We also force links to open in a new tab with noopener so a
// sanitized <a> can't reverse-tabnab the CRM.
let hookRegistered = false;
function registerHook() {
  if (hookRegistered) return;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node instanceof HTMLElement && node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  hookRegistered = true;
}

export function sanitizeEmailHtml(html: string | null | undefined): string {
  if (!html) return "";
  registerHook();
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
  });
}
